
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateForm } from "utils/validation";
import { PackageFoodTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditPFTLForm from "./Componates/EditPFTLForm";
import fields from "../json/FoodListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import {
  Update,  
  getFoodTypes,
  getFoodPackage,
  GetById
} from "adminApi/PackageFoodTypeLimitApi/PackageFoodTypeLimit.js";

const EditPFTL = () => {

  const navigate = useNavigate();
  const { formdata } = fields;
  const { id } = useParams();

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors, setValues } = useFormChange(
    initialValues,
    PackageFoodTypeRules
  );

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(
    id,
    formdata,
    GetById,
    setValues
  );

  const { data: FoodTypesOptions = [] } = useFetchAllData(getFoodTypes);
  const { data: FoodPackageOptions = [] } = useFetchAllData(getFoodPackage);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Update({ id, data: formData });
    },
    (vals) => {
      const err = validateForm(vals, PackageFoodTypeRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Updated Package Food Type Limit Successfully"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <EditPFTLForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        FoodTypesOptions={FoodTypesOptions}
        FoodPackageOptions={FoodPackageOptions}
        title="Update Package Food Type Limit"
      />
    </>
  );

};

export default EditPFTL;
